require("intersection-observer")

import "./src/scss/base/base.scss"
